if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.container = this;
      this.section = this.container.closest('.shopify-section');

      this.timeZone = this.container.dataset.timezone || 'America/Los_Angeles';
      this.countdownType = this.container.dataset.countdownType || 'once';
      this.countdownDuration = this.container.dataset.duration || '00:00:00:00';

      this.countdownEnd;
  
      this.second = 1000;
      this.minute = this.second * 60;
      this.hour = this.minute * 60;
      this.day = this.hour * 24;

      this.startCountdown();
    }

    parseDuration(durationStr) {
      const [days, hours, minutes, seconds] = durationStr.split(':').map(Number);
      return (days * this.day) + (hours * this.hour) + (minutes * this.minute) + (seconds * this.second);
    }

    getDateTimeInTimeZone(dateStr, timeZone) {
      try {
        const options = { timeZone };
        const dateTime = new Date(dateStr).toLocaleString('en-US', options);
        return new Date(dateTime);
      } catch (e) {
        return new Date(dateStr);
      }
    }

    startCountdown() {
      const x = setInterval(() => {
        const now = this.getDateTimeInTimeZone(new Date().toISOString(), this.timeZone).getTime();

        if (this.countdownType === 'once') {
          if (!this.countdownEnd) {
            const deadlineStr = this.container.dataset.deadline;
            this.countdownEnd = new Date(deadlineStr).getTime();
          }
        } else if (this.countdownType === 'infinite') {
          if (!this.countdownEnd || now >= this.countdownEnd) {
            const duration = this.parseDuration(this.countdownDuration);

            if (!this.countdownEnd || now >= this.countdownEnd) {
              this.countdownEnd = now + duration;
              // if (this.countdownEnd > now + this.day) {
              //   this.countdownEnd -= this.day; // Виправлення, яке забезпечує, що різниця не перевищує 24 години
              // }
            }
          }
        }

        const distance = this.countdownEnd - now;

        if (distance > 0) {
          const days = Math.floor(distance / this.day),
          hours = Math.floor((distance % this.day) / this.hour),
          minutes = Math.floor((distance % this.hour) / this.minute),
          seconds = Math.floor((distance % this.minute) / this.second);

          this.container.querySelector("#days-mob").innerText = days.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false}),
          this.container.querySelector("#hours-mob").innerText = hours.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false}),
          this.container.querySelector("#minutes-mob").innerText = minutes.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false}),
          this.container.querySelector("#seconds-mob").innerText = seconds.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false});
        } else {
          if (this.container.closest('.featured-product__content')){
            if(this.section.querySelector('.featured-collection__content')){

              this.section.querySelector('[data-section-type="featured-product-collection"]').classList.add('mc__section__only_product_list');

              this.section.querySelector('.featured-collection__content').prepend(this.section.querySelector('.featured-collection__content .countdown__timer-title'))
              this.section.querySelector('header').append(this.section.querySelector('.featured-collection__content countdown-timer'))
              
            }
            this.container.closest('.featured-product__content').remove();
          }
          if (this.container.closest('.featured-collection__content')) this.container.closest('.featured-collection__content').remove();
          
          clearInterval(x);
        }
      }, 1000);
    }
  });
}